module.exports = __webpack_public_path__ + "static/media/budget-graph.38159ba7.svg";